import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import * as _ from 'lodash';
import { PledgeProductRead } from '../../definition/interface/Pledge';
import { FormConfig } from '../../definition/types/subscription';
import FormGroupArray from '../../services/FormGroupArray';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  options: any = {};

  generateForm(entity: PledgeProductRead & { parameters: any }, options) {
    this.options = { ...options, ...entity };

    let supportRepartition: UntypedFormGroup[] = [];

    const supportRepartitionFound = _.filter(
      entity?.parameters?.supportRepartition,
      o => {
        return o?.type != 'EURO_FOUND';
      },
    );

    //const supportRepartitionIsin = entity?.supportRepartition;
    const supportRepartitionIsin = supportRepartitionFound || [];
    const avOptionSecurisationPlusValuesLimits =
      entity?.parameters?.avOptionSecurisationPlusValuesLimits || [];

    const avOptionSecurisationPlusValuesLimitsMerged =
      avOptionSecurisationPlusValuesLimits?.length
        ? avOptionSecurisationPlusValuesLimits
        : _.merge(avOptionSecurisationPlusValuesLimits, supportRepartitionIsin);

    if (avOptionSecurisationPlusValuesLimitsMerged?.length) {
      _.forEach(avOptionSecurisationPlusValuesLimitsMerged, (scpi, i) =>
        supportRepartition.push(this.formBuilder.group(this.createModel(scpi))),
      );
    } else {
      supportRepartition.push(this.formBuilder.group(this.createModel({})));
    }

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        avOptionSecurisationPlusValuesTotaliteSupport: [
          entity?.parameters?.avOptionSecurisationPlusValuesTotaliteSupport ||
            false,
        ],
        productPackId: [entity?.parameters?.productPackId],
        avOptionSecurisationPlusValuesLimits: this.formBuilder.array(
          supportRepartition,
          Validators.nullValidator,
        ),
      }),
    };

    return this.formBuilder.group(formConfig, {});
  }
  generate(entity: any[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }
  get products() {
    return this.form.get('products') as UntypedFormArray;
  }
  get avOptionSecurisationPlusValuesLimits() {
    return this.products
      .get(`${0}`)
      .get('parameters')
      .get('avOptionSecurisationPlusValuesLimits') as UntypedFormArray;
  }
  public createModel(item) {
    let model = {
      id: [item ? item.id : null],
      isin: [item ? item.isin || item.supportIsin : null],
      index: [item ? item.index : null],
      omniprodId: [item ? item.omniProductId || item.omniprodId : null],
      name: [item ? item.name : null],
      initalRepartition: [item ? +item.initalRepartition : null],
      monthlyRepartition: [item ? +item.monthlyRepartition : null],
      favorite: [item ? item.favorite : null],
      type: [item ? item.type : null],
      supportDescription: [
        this.options ? this.options.supportDescription : null,
      ],
      totalAvInitialPayment: [
        this.options && this.options?.parameters
          ? +this.options?.parameters.avInitialPayment
          : null,
      ],
      totalAvMonthlyPayment: [
        this.options && this.options?.parameters
          ? +this.options?.parameters.avMonthlyPayment
          : null,
      ],
      limit: [
        item ? item.limit : null,
        //  Validators.required
      ],
      limitCustom: [
        item && item.limitCustom ? (item.limitCustom * 100).toFixed(2) : null,
        // [Validators.max(1), Validators.min(0)],
      ],
    };
    return model;
  }

  extract() {
    const formValue =
      this.form.value?.products?.[0]?.parameters
        ?.avOptionSecurisationPlusValuesLimits;
    const supportRepartition = _.filter(formValue, o => {
      return o.isin != undefined || o.isin != null;
    });
    const firstElemnt = supportRepartition[0];
    const avTotalite =
      this.form.value?.products?.[0]?.parameters
        ?.avOptionSecurisationPlusValuesTotaliteSupport;

    const supportRepartitionIsin = _.map(supportRepartition, o => {
      return {
        type: o.type,
        isin: o.isin,
        name: o.name,
        limit: avTotalite ? firstElemnt.limit : o.limit,
        limitCustom: avTotalite
          ? firstElemnt.limitCustom / 100
          : o.limitCustom / 100,
      };
    });

    const products = this.form.value?.products;
    const productsIsin = _.map(products, o => {
      return {
        ...o,
        parameters: {
          ...o.parameters,
          avOptionSecurisationPlusValuesLimits: supportRepartitionIsin,
        },
      };
    });
    return productsIsin;
  }
}
